import React from 'react';

const NewProductForm = ({
  showNewProductForm,
  newProductData,
  setNewProductData,
  handleAddNewProduct,
  setShowNewProductForm
}) => {
  if (!showNewProductForm) return null;

  return (
    <div className="modal-overlay">
      <div className="modal-content">
        <h3>Add New Product</h3>
        <div className="modal-form">
          <div className="form-group">
            <label>Product Name:</label>
            <input
              type="text"
              value={newProductData.name}
              onChange={(e) => setNewProductData({...newProductData, name: e.target.value})}
            />
          </div>
          <div className="form-group">
            <label>Category:</label>
            <input
              type="text"
              value={newProductData.category}
              onChange={(e) => setNewProductData({...newProductData, category: e.target.value})}
            />
          </div>
          <div className="form-group">
            <label>Specifications:</label>
            <input
              type="text"
              value={newProductData.specifications}
              onChange={(e) => setNewProductData({...newProductData, specifications: e.target.value})}
            />
          </div>
          <div className="modal-buttons">
            <button onClick={handleAddNewProduct}>Save</button>
            <button onClick={() => setShowNewProductForm(false)}>Cancel</button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default NewProductForm;
